import { render, staticRenderFns } from "./BotaoPssc.vue?vue&type=template&id=01b7f931&lang=pug"
import script from "./BotaoPssc.vue?vue&type=script&lang=js"
export * from "./BotaoPssc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports